<div class="datepicker-wrapper">
    <div class="datepicker-wrapper-control">
        <div *ngIf="hasFilterEnabled()" class="datepicker-wrapper-filter">
            <fc-ag-drop-down-list [items]="filterItems"
                                  [(selectedItems)]="selectedFilterItem"
                                  (selectionChange)="onFilterChange($event)"
                                  [selectionHelper]="false"
                                  dropdownPlaceholder="Filter By"
                                  [bindLabel]="filterBindingValue"
                                  [bindValue]="filterBindingKey"
            ></fc-ag-drop-down-list>
        </div>
        <div #datepickerWrapper  class="datepicker-wrapper-input-calendar">
            <label class="dropdown-label" *ngIf="dropdownLabel && !hasDatepickerData()">
                {{ dropdownLabel }}
            </label>
            <input type="text"
                   #datepickerInput
                   readonly
                   class="input"
                   [ngClass]="{ 'has-filter-enabled': hasFilterEnabled(), 'has-datepicker-data': hasDatepickerData()}"
                   [placeholder]="inputPlaceholder"
                   [value]="getInputValueLabel()"
                   [title]="getInputValueLabel()"
                   (click)="showCalendar = !showCalendar"
            />
            <div class="clear-date"
                 [hidden]="!allowClear || (allowClear && hasDatepickerData())"
                 (click)="clearDatePickerData()">
            </div>
            <div #datepickerIcon
                (click)="showCalendar = !showCalendar"
                 class="datepicker-icon">
            </div>
        </div>
    </div>

    <div #datepickerPanelWrapper class="datepicker-wrapper-calendar-panel"
         [hidden]="!showCalendar">
        <ng-container *ngTemplateOutlet="isSingleCalendar() ? singleCL : rangeCL"></ng-container>
        <ng-container *ngTemplateOutlet="(extraFooter ? extraFooter : null); context: { thiz: this}"></ng-container>
    </div>

</div>
<ng-template #singleCL>
    <div class="single-datepicker-wrapper">
        <fc-ag-calendar [selectedDate]="datepickerData.startDate"
                        [minDate]="minDate"
                        [maxDate]="maxDate"
                        [allowSelectMonthYear]="allowSelectMonthYear"
                (dateSelection)="onCalendarDateChange($event)"></fc-ag-calendar>
    </div>
</ng-template>
<ng-template #rangeCL>
    <div class="range-datepicker-wrapper">
        <div class="calendar-wrapper left-calendar">
            <label class="calendar-label">From Date</label>
            <fc-ag-calendar [selectedDate]="datepickerData.startDate"
                            [minDate]="minDate"
                            [maxDate]="maxDate"
                            [allowSelectMonthYear]="allowSelectMonthYear"
                            (dateSelection)="onCalendarFromChange($event)"></fc-ag-calendar>
        </div>
        <div class="calendar-wrapper right-calendar">
            <label class="calendar-label">To Date</label>
            <fc-ag-calendar [selectedDate]="datepickerData.endDate"
                            [dateGenerator]="rangeEndDateGenerator"
                            [allowSelectMonthYear]="allowSelectMonthYear"
                            [minDate]="minDate"
                            [maxDate]="maxDate"
                            (dateSelection)="onCalendarToChange($event)"></fc-ag-calendar>
        </div>
    </div>
</ng-template>